import { collection, doc, getDocs, updateDoc } from "@firebase/firestore";
import { Button, Card, Col, Form, Row, Select } from "antd";
import React, { useEffect, useState } from "react";
import { toast } from "react-hot-toast";
import { v4 as uuidv4 } from "uuid";
import { db } from "../../../../firebase";

const PropertyGroups = ({ companyName, dataId }) => {
  const [isEditActive, setIsEditActive] = useState(false);

  const [prtyGroups, setPrtyGroups] = useState([]);

  useEffect(() => {
      const fetchPropertyGroups = async () => {
        try {
          const propertyRef = collection(
            db,
            "companies",
            companyName,
            "propertyGroups"
          );
          const snapshot = await getDocs(propertyRef);
          const fetchedData = snapshot.docs.map((doc) => ({
            id: doc.id,
            value: doc.id,
            label: doc.data().propertyGroupName,
            ...doc.data(),
          }));
          setPrtyGroups(fetchedData);
        } catch (err) {
          console.error(err);
          alert(err.message);
        }
      };
      fetchPropertyGroups();
  
  }, [companyName]);

  console.log("Property groups: ", prtyGroups);

  const [propertyGroups, setPropertyGroups] = useState([
    { id: uuidv4(), propertyGroupId: "" },
  ]);

  console.log("Property groups############ ", propertyGroups);
  const getPropertyGroups = async () => {
    try {

      const propertyRef = collection(db, "companies", companyName, "properties");
      const snapshot = await getDocs(propertyRef);
      const fetchedData = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));
      
      const filteredProperty = fetchedData.find((item) => item.id === dataId);
      const propertyGroups = filteredProperty?.propertyGroups || [{ id: uuidv4(), propertyGroupId: "" }];
      setPropertyGroups(propertyGroups);
    } catch (err) {
      console.error(err);
      alert(err.message);
    }
  };
  
  useEffect(() => {
    getPropertyGroups();
  }, [companyName, isEditActive]); // Combine all dependencies into a single useEffect
  
  

  const addPropertyGroup = () => {
    const newPropertyGroup = {
      id: uuidv4(),
      propertyGroupId: "",
    };
    setPropertyGroups([...propertyGroups, newPropertyGroup]);
  };

  const removePropertyGroup = (id) => {
    const updatedPropertyGroups = propertyGroups.filter(
      (propertyGroup) => propertyGroup.id !== id
    );
    setPropertyGroups(updatedPropertyGroups);
  };

  const handleChange = (value, id) => {
    const updatedPropertyGroups = propertyGroups.map((propertyGroup) => {
      if (propertyGroup.id === id) {
        return { ...propertyGroup, propertyGroupId: value };
      }
      return propertyGroup;
    });
    setPropertyGroups(updatedPropertyGroups);
  };

  const onFinish = async () => {
    const propertyRef = doc(db, "companies", companyName, "properties", dataId);
    const prtyGroup = {
      propertyGroups: propertyGroups,
    };

    try {
      await updateDoc(propertyRef, prtyGroup);
      setIsEditActive(false);
      toast.success("update successful");
    } catch (err) {
      console.log("Update failed", err);
    }
  };

  const onFinishFailed = (err) => {
    console.log("Update failed", err);
  };

  console.log("seroooooooooooooooo:", propertyGroups);

  const [propertyGroupNames, setPropertyGroupNames] = useState([]);

  useEffect(() => {
    console.log("prtyGroups: ", prtyGroups);
    console.log("propertyGroups: ", propertyGroups);

    const resultArray = propertyGroups.map((property) => {
      const matchingProperty = prtyGroups.find(
        (item) => item.id === property.propertyGroupId
      );
      console.log("matching Property: ", matchingProperty);
      return matchingProperty ? matchingProperty.propertyGroupName : null;
    });

    setPropertyGroupNames(resultArray);
  }, [companyName, prtyGroups, propertyGroups]);

  console.log("Resulted array", propertyGroupNames);
  return (
    <div>
      <Card
        title="Property Groups"
        extra={
          !isEditActive ? (
            <Button
              type="link"
              onClick={() => {
                setIsEditActive(true);
              }}
            >
              Edit
            </Button>
          ) : (
            ""
          )
        }
      >
        <Form
          name="basic"
          labelCol={{
            span: 8,
          }}
          autoComplete="off"
          colon={false}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
        >
          {isEditActive ? (
            <ul>
              {propertyGroups.map((item) => (
                <li key={item.id}>
                  <Form.Item label="">
                    <Row>
                      <Col span={23}>
                        <Select
                          showSearch
                          style={{ width: "100%" }}
                          options={prtyGroups}
                          value={item.propertyGroupId}
                          onChange={(value) => handleChange(value, item.id)}
                        />
                      </Col>
                      <Col span={1}>
                        {propertyGroups.length > 1 ? (
                          <Button
                            className="roundSmallButton"
                            onClick={() => {
                              removePropertyGroup(item.id);
                            }}
                            type="primary"
                            shape="circle"
                            icon={
                              <i className="fa-sharp fa-solid fa-xmark"></i>
                            }
                            size={"small"}
                          />
                        ) : (
                          <></>
                        )}
                      </Col>
                    </Row>
                  </Form.Item>
                </li>
              ))}
              <Form.Item label="">
                <Button
                  className="addPropertyGroupButton"
                  type="primary"
                  onClick={addPropertyGroup}
                  size={"small"}
                  icon={<i className="fa-solid fa-circle-plus"></i>}
                >
                  Add Another Line
                </Button>
              </Form.Item>
            </ul>
          ) : (
            <Form.Item label="Property Groups">
              {propertyGroupNames.map((item, index) => (
                <span key={index}>{item}, </span>
              ))}
            </Form.Item>
          )}
          {isEditActive && (
            <Row gutter={16}>
              <Col>
                <Button type="primary" htmlType="submit">
                  Save
                </Button>
              </Col>
              <Col>
                <Button
                  onClick={() => {
                    setIsEditActive(false);
                  }}
                >
                  Cancel
                </Button>
              </Col>
            </Row>
          )}
        </Form>
      </Card>
    </div>
  );
};

export default PropertyGroups;
